// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__CFxkd","loaderOuter":"PageOverlayLoader_loaderOuter__j0wTX"};